import Vue from "vue";
import base from "../baseMarketing";

export default Object.assign(
  {
    apiUrl: "/report",

    async getSimpleReport() {
      return Vue.http({
        url: this.url("/simple"),
        method: "GET",
        responseType: "blob",
      });
    },
  },
  base
);
